import type { ClientPersonExtendedUpdateRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useParticipantsPersonEventsApi } from '@/features/api/hooks/participant/useParticipantsPersonEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const usePersonExtendedUpdate = () => {
  const queryClient = useQueryClient();
  const api = useParticipantsPersonEventsApi();

  return useApiMutation({
    mutationFn: (
      clientPersonExtendedUpdateRequest: ClientPersonExtendedUpdateRequest
    ) =>
      api.onPersonExtendedUpdateRequest({ clientPersonExtendedUpdateRequest }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_CACHE_KEYS.PERSON] });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.POST_CREATION_OPTIONS]
      });
    }
  });
};
